<template>
  <v-container fluid pa-0 ma-0 grid-list-md>
    <v-layout row wrap>
      <v-flex xs4>
        <v-layout column justify-center>
          <!-- WEATHER CARD START -->
          <v-flex xs4>
            <Card>
              <v-layout
                row
                wrap
                align-center
                justify-center
                pa-3
                ma-0
                class="main-card"
              >
                <v-flex xs3>
                  <div class="accent--text scada-body-2">
                    {{ $t("Next hour forecast") }}
                  </div>
                  <img src="../assets/weather.png" class="clouded-png" />
                </v-flex>
                <v-flex xs3>
                  <div class="text-xs-center scada-title font-weight-bold">
                    <span
                      :class="
                        weatherData['Temperature']
                          ? 'number--text'
                          : 'error--text'
                      "
                    >
                      {{
                        weatherData["Temperature"]
                          ? weatherData["Temperature"]
                          : "N/A"
                      }}
                    </span>
                  </div>
                  <div class="text-xs-center scada-title">
                    {{ $t(weatherData["Condition"].toLowerCase()) }}
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div class="text-xs-right scada-subheading">
                    <span
                      >{{ $t("Irradiance") }} :
                      <span
                        :class="
                          weatherData['Irradiance']
                            ? 'number--text'
                            : 'error--text'
                        "
                      >
                        {{
                          weatherData["Irradiance"]
                            ? weatherData["Irradiance"]
                            : "N/A"
                        }}
                      </span></span
                    >
                  </div>
                  <div class="text-xs-right scada-subheading">
                    <span
                      >{{ $t("Humidity") }} :
                      <span
                        :class="
                          weatherData['Humidity']
                            ? 'number--text'
                            : 'error--text'
                        "
                      >
                        {{
                          weatherData["Humidity"]
                            ? weatherData["Humidity"]
                            : "N/A"
                        }}
                      </span></span
                    >
                  </div>
                  <div class="text-xs-right scada-subheading">
                    <span
                      >{{ $t("Wind Speed") }} :
                      <span
                        :class="
                          weatherData['Wind Speed']
                            ? 'number--text'
                            : 'error--text'
                        "
                      >
                        {{
                          weatherData["Wind Speed"]
                            ? weatherData["Wind Speed"]
                            : "N/A"
                        }}
                      </span></span
                    >
                  </div>
                  <div class="text-xs-right scada-subheading">
                    <span
                      >{{ $t("Wind Direction") }} :
                      <span
                        :class="
                          weatherData['Wind Direction']
                            ? 'number--text'
                            : 'error--text'
                        "
                      >
                        {{
                          weatherData["Wind Direction"]
                            ? weatherData["Wind Direction"]
                            : "N/A"
                        }}
                      </span></span
                    >
                  </div>
                </v-flex>
              </v-layout>
            </Card>
          </v-flex>
          <!-- WEATHER CARD END -->

          <!-- GEN CARD START-->
          <v-flex xs4>
            <Card>
              <v-layout
                row
                wrap
                align-center
                justify-center
                pa-0
                ma-0
                class="main-card"
              >
                <v-flex xs12>
                  <div class="text-xs-center scada-title font-weight-bold">
                    {{ $t("Generation Data") }}
                  </div>
                  <div class="text-xs-center extraGrey--text scada-body-2">
                    {{ $t("Data upto previous hour") }}
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div
                    class="text-xs-center body-1 extraGrey--text font-weight-medium"
                  >
                    {{ $t("Actual Gen") }}
                  </div>
                  <div class="text-xs-center">
                    <span
                      :class="
                        actualTotalGen
                          ? 'number--text scada-title font-weight-bold'
                          : 'error--text scada-title font-weight-bold'
                      "
                      >{{ actualTotalGen ? actualTotalGen : "N/A" }}</span
                    >
                    <span class="scada-body-2" mt-2>
                      {{ actualTotalGen ? "kWh" : "" }}</span
                    >
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div
                    class="text-xs-center body-1 extraGrey--text font-weight-medium"
                  >
                    {{ $t("Forecasted Gen") }}
                  </div>
                  <div class="text-xs-center">
                    <span
                      :class="
                        forecastedTotalGen
                          ? 'number--text scada-title font-weight-bold'
                          : 'error--text scada-title font-weight-bold'
                      "
                    >
                      {{ forecastedTotalGen ? forecastedTotalGen : "N/A" }}
                    </span>
                    <span class="scada-body-2">
                      {{ forecastedTotalGen ? "kWh" : "" }}
                    </span>
                  </div>
                </v-flex>
              </v-layout>
            </Card>
          </v-flex>
          <!-- GEN CARD END-->

          <!-- PENALTY TREND START-->
          <v-flex xs4>
            <Card>
              <v-layout
                row
                wrap
                align-center
                justify-space-around
                pa-0
                ma-0
                class="main-card"
              >
                <v-flex xs12>
                  <div class="text-xs-center scada-title font-weight-bold">
                    {{ $t("Penalty Trend") }}
                  </div>
                  <div class="text-xs-center extraGrey--text scada-body-2">
                    {{ $t("Trend compared upto previous hour") }}
                  </div>
                </v-flex>
                <v-flex xs4>
                  <div
                    class="text-xs-center body-1 extraGrey--text font-weight-medium"
                  >
                    {{ $t("Today") }}
                  </div>
                  <div class="text-xs-center">
                    <span
                      :class="
                        penaltyTrend['Today']
                          ? 'number--text scada-title font-weight-bold'
                          : 'error--text scada-title font-weight-bold'
                      "
                      >{{
                        penaltyTrend["Today"] ? penaltyTrend["Today"] : "N/A"
                      }}</span
                    ><span class="scada-body-2">
                      {{ penaltyTrend["Today"] ? "INR" : "" }}</span
                    >
                  </div>
                </v-flex>
                <v-flex xs4>
                  <div
                    class="text-xs-center body-1 extraGrey--text font-weight-medium"
                  >
                    {{ $t("Yesterday") }}
                  </div>
                  <div class="text-xs-center">
                    <span
                      :class="
                        penaltyTrend['Yesterday']
                          ? 'number--text scada-title font-weight-bold'
                          : 'error--text scada-title font-weight-bold'
                      "
                      >{{
                        penaltyTrend["Yesterday"]
                          ? penaltyTrend["Yesterday"]
                          : "N/A"
                      }}</span
                    ><span class="scada-body-2">
                      {{ penaltyTrend["Yesterday"] ? "INR" : "" }}</span
                    >
                  </div>
                </v-flex>
                <v-flex xs4>
                  <div
                    class="text-xs-center body-1 extraGrey--text font-weight-medium"
                  >
                    {{ $t("Trend") }}
                  </div>
                  <div class="text-xs-center">
                    <v-icon class="scada-icon-medium">
                      {{
                        penaltyTrend["Trend"] == "UP"
                          ? "arrow_upward"
                          : penaltyTrend["Trend"]
                          ? "arrow_downward"
                          : ""
                      }}
                    </v-icon>
                    <span
                      :class="
                        penaltyTrend['Diff']
                          ? 'number--text scada-title font-weight-bold'
                          : 'error--text scada-title font-weight-bold'
                      "
                      >{{
                        penaltyTrend["Diff"] ? penaltyTrend["Diff"] : "N/A"
                      }}</span
                    ><span class="scada-body-2">
                      {{ penaltyTrend["Diff"] ? "INR" : "" }}</span
                    >
                  </div>
                </v-flex>
              </v-layout>
            </Card>
          </v-flex>
          <!-- PENALTY TREND END-->
        </v-layout>
      </v-flex>

      <!-- GRAPH START-->
      <v-flex xs8>
        <v-layout row justify-center>
          <v-flex>
            <Card class="line-chart-card">
              <v-card-text>
                <div class="d-flex align-center">
                  <v-flex xs8 class="text-xs-center">
                    <div class="scada-title font-weight-bold">
                      {{ $t("Actual Data vs Forecasted Data") }}
                    </div>
                    <div class="extraGrey--text text-xs-center scada-body-2">
                      {{
                        $t(
                          "Data comparision for actual generation vs forecasted generation"
                        )
                      }}
                    </div>
                  </v-flex>
                  <v-flex xs3>
                    <Toggle
                      :modelValue="currentView"
                      :theme="theme"
                      @toggleValueChange="(val) => (currentView = val)"
                    >
                      <v-btn flat value="graph" class="scada-toggle-height">
                        <span class="scada-btn-font">{{ $t("Graph") }}</span>
                        <v-icon>bar_chart</v-icon>
                      </v-btn>
                      <v-btn flat value="table" class="scada-toggle-height">
                        <span class="scada-btn-font">{{ $t("Table") }}</span>
                        <v-icon>table_chart</v-icon>
                      </v-btn>
                    </Toggle>
                  </v-flex>
                  <v-flex xs2>
                    <v-select
                      :items="models"
                      v-model="graphModel"
                      :menu-props="{ auto: true, overflowY: true }"
                      dense
                      color="white"
                    />
                  </v-flex>
                  <v-flex></v-flex>
                </div>
              </v-card-text>
              <div v-show="currentView == 'graph'">
                <GlobalGraph
                  v-if="series.length"
                  :series="series"
                  :xAxisData="xAxis"
                  :yAxis="yAxis"
                  :theme="theme"
                  class="graph"
                />
              </div>
              <div v-if="currentView == 'table'">
                <TableButtons
                  :isReload="false"
                  :isEmit="true"
                  @download:report="() => download()"
                />
                <div>
                  <RecyclerDataTable
                    v-if="forecastTableData.length"
                    :items="forecastTableData"
                    :headers="forecastTableHeader"
                    :key_field="'time'"
                    :tableHeight="tableHeight"
                  />
                </div>
              </div>
            </Card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- GRAPH END -->

      <!-- PIE CHART START-->
      <v-flex xs4>
        <v-layout column justify-center>
          <v-flex xs4>
            <Card class="pie-chart-card">
              <v-card-text class="scada-subheading">
                <div class="d-flex align-center">
                  <v-flex xs4> </v-flex>
                  <v-flex xs4>
                    <Toggle
                      :modelValue="pieView"
                      :theme="theme"
                      @toggleValueChange="(val) => (pieView = val)"
                    >
                      <v-btn class="scada-toggle-height" flat value="dev">
                        <span class="scada-btn-font">{{
                          $t("Deviation")
                        }}</span>
                      </v-btn>
                      <v-btn class="scada-toggle-height" flat value="rev">
                        <span class="scada-btn-font">{{ $t("Revision") }}</span>
                      </v-btn>
                    </Toggle>
                  </v-flex>
                </div>
              </v-card-text>
              <div v-show="pieView == 'dev'">
                <!-- radius: ['40', '90'], -->
                <GlobalGraph
                  class="pie-graph"
                  :isMagicType="false"
                  :series="[
                    {
                      name: $t('Range and Deviation'),
                      center: ['50%', '50%'],
                      bottom: '5%',
                      type: 'pie',
                      radius: ['40%', '75%'],
                      avoidLabelOverlap: false,
                      itemStyle: {
                        borderRadius: 10,
                        borderColor: '#fff',
                        borderWidth: 1,
                      },
                      data: pieData,
                    },
                  ]"
                  :isHoverFix="false"
                  :legendPosition="legend"
                  :theme="theme"
                />
              </div>
              <div v-if="pieView == 'rev'">
                <template v-if="items.length">
                  <Card
                    class="revision-card"
                    v-for="item in items"
                    :key="`${item.revisionNo}-${item.date}`"
                  >
                    <v-layout pa-3 ma-0>
                      <v-flex xs6>
                        <div>R-{{ item.revisionNo }}</div>
                        <div>{{ $t("Generation") }}: {{ item.generation }}</div>
                        <div>{{ $t("Reason") }}: {{ item.reason }}</div>
                        <div>{{ $t("Time") }}: {{ item.date }}</div>
                      </v-flex>
                      <v-divider vertical></v-divider>
                      <v-flex xs6>
                        <div>{{ $t("Remarks") }}</div>
                        <div>{{ item.remarks }}</div>
                      </v-flex>
                    </v-layout>
                  </Card>
                </template>
                <Card v-else>
                  <v-flex pa-3 class="scada-subheading error--text">
                    {{ $t("No Data") }}
                  </v-flex>
                </Card>
              </div>
            </Card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- PIE CHART END-->

      <v-flex xs8>
        <v-layout row>
          <!-- SUMMARY CARD START-->
          <v-flex xs6>
            <Card class="range-card">
              <v-layout
                row
                wrap
                align-center
                justify-space-around
                pa-0
                ma-0
                class="range-card"
              >
                <v-flex xs12>
                  <div class="text-xs-center scada-title font-weight-bold">
                    {{ $t("Trend Table") }}
                  </div>
                  <div class="text-xs-center extraGrey--text scada-body-2">
                    {{ $t("Generation/weather parameters trend") }}
                  </div>
                </v-flex>
                <v-flex xs3>
                  <div
                    class="text-xs-center body-1 extraGrey--text font-weight-medium"
                  >
                    {{ $t("Parameters") }}
                  </div>
                </v-flex>
                <v-flex xs3>
                  <div
                    class="text-xs-center body-1 extraGrey--text font-weight-medium"
                  >
                    {{ $t("Actual") }}
                  </div>
                </v-flex>
                <v-flex xs3>
                  <div
                    class="text-xs-center body-1 extraGrey--text font-weight-medium"
                  >
                    {{ $t("Forecast") }}
                  </div>
                </v-flex>
                <v-flex xs3>
                  <div
                    class="text-xs-center body-1 extraGrey--text font-weight-medium"
                  >
                    {{ $t("Trend") }}
                  </div>
                </v-flex>
                <template v-if="Object.keys(summary).length">
                  <!-- TODO: fix the key issue -->
                  <template v-for="p in Object.keys(summary)">
                    <v-flex xs3 :key="`${p}-actual${summary[p]['forecast']}`">
                      <div class="text-xs-center body-1 font-weight-medium">
                        {{ p }}
                      </div>
                    </v-flex>
                    <v-flex xs3 :key="`${p}-${summary[p]['forecast']}`">
                      <div
                        :class="
                          summary[p]['actual'] == null ||
                          summary[p]['actual'] == 'No Data'
                            ? 'error--text text-xs-center scada-title font-weight-bold'
                            : 'number--text text-xs-center scada-title font-weight-bold'
                        "
                      >
                        {{ summary[p]["actual"] }}
                      </div>
                    </v-flex>
                    <v-flex xs3 :key="`${p}-forecast${summary[p]['forecast']}`">
                      <div
                        :class="
                          summary[p]['forecast'] == null ||
                          summary[p]['forecast'] == 'No Data'
                            ? 'error--text text-xs-center scada-title font-weight-bold'
                            : 'number--text text-xs-center scada-title font-weight-bold'
                        "
                      >
                        {{ summary[p]["forecast"] }}
                      </div>
                    </v-flex>
                    <v-flex xs3 :key="`${p}-trend${summary[p]['forecast']}`">
                      <div class="text-xs-center">
                        <v-icon class="scada-icon-medium">
                          {{
                            summary[p]["trend"] == "UP"
                              ? "arrow_upward"
                              : summary[p]["trend"]
                              ? "arrow_downward"
                              : ""
                          }}
                        </v-icon>
                        <span
                          :class="
                            summary[p]['trendValue'] == null ||
                            summary[p]['trendValue'] == 'No Data'
                              ? 'error--text text-xs-center scada-title font-weight-bold'
                              : 'number--text text-xs-center scada-title font-weight-bold'
                          "
                        >
                          {{
                            summary[p]["trendValue"] == null
                              ? "N/A"
                              : summary[p]["trendValue"]
                          }}
                        </span>
                      </div>
                    </v-flex>
                  </template>
                </template>
                <template v-else>
                  <v-flex>
                    <div class="text-xs-center headline error--text">N/A</div>
                  </v-flex>
                </template>
              </v-layout>
            </Card>
          </v-flex>
          <!-- SUMMARY CARD END-->

          <!-- GEN VS PENALTY CARD START-->
          <v-flex xs6>
            <Card class="range-card">
              <v-layout
                row
                wrap
                align-center
                justify-space-around
                pa-0
                ma-0
                class="range-card"
              >
                <v-flex xs12>
                  <div class="text-xs-center scada-title font-weight-bold">
                    {{ $t("Generation vs Penalty") }}
                  </div>
                  <div class="text-xs-center extraGrey--text scada-body-2">
                    {{ $t("Data compared to deviation range") }}
                  </div>
                </v-flex>
                <v-flex xs4>
                  <div
                    class="text-xs-center body-1 extraGrey--text font-weight-medium"
                  >
                    {{ $t("Range") }} <span class="scada-subheading">(%)</span>
                  </div>
                </v-flex>
                <v-flex xs4>
                  <div
                    class="text-xs-center body-1 extraGrey--text font-weight-medium"
                  >
                    {{ $t("Generation") }}
                    <span class="scada-subheading">(kWh)</span>
                  </div>
                </v-flex>
                <v-flex xs4>
                  <div
                    class="text-xs-center body-1 extraGrey--text font-weight-medium"
                  >
                    {{ $t("Penalty") }}
                    <span class="scada-subheading">(INR)</span>
                  </div>
                </v-flex>

                <template v-if="Object.keys(penalty.details).length">
                  <template v-for="(p, index) in Object.keys(penalty.details)">
                    <v-flex xs4 :key="`${p}-${index}`">
                      <div class="text-xs-center body-1 scada-subheading">
                        {{ p }}
                      </div>
                    </v-flex>
                    <v-flex xs4 :key="`${p}-${index}`">
                      <div
                        :class="
                          penalty.details[p].gen
                            ? 'number--text text-xs-center scada-title font-weight-bold'
                            : 'error--text text-xs-center scada-title font-weight-bold'
                        "
                      >
                        {{ penalty.details[p].gen.toFixed(2) }}
                      </div>
                    </v-flex>
                    <v-flex xs4 :key="`${p}-${index}`">
                      <div
                        :class="
                          penalty.details[p].penalty
                            ? 'number--text text-xs-center scada-title font-weight-bold'
                            : 'error--text text-xs-center scada-title font-weight-bold'
                        "
                      >
                        {{ penalty.details[p].penalty.toFixed(2) }}
                      </div>
                    </v-flex>
                  </template>
                </template>
                <template v-else>
                  <v-flex>
                    <div class="text-xs-center scada-title error--text">
                      N/A
                    </div>
                  </v-flex>
                </template>
              </v-layout>
            </Card>
          </v-flex>
          <!-- GEN VS PENALTY CARD END-->
        </v-layout>
      </v-flex>
    </v-layout>

    <v-speed-dial v-model="fab" fixed right bottom small class="hidden-xs-only">
      <template slot="activator">
        <v-btn
          @click="activateTooltip"
          color="accent"
          class="padding-button"
          fab
        >
          <v-icon>more_horiz</v-icon>
        </v-btn>
      </template>
      <div class="primary darken-1 pa-2">
        <div>
          <v-layout column align-center>
            <v-flex>
              <v-btn @click="() => (dialog = true)" small color="blue" fab>
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-flex>
            <v-flex>{{ $t("Revision") }}</v-flex>
          </v-layout>
          <v-divider></v-divider>
        </div>
      </div>
    </v-speed-dial>
    <v-card class="primary primaryText--text" dark>
      <v-dialog v-model="dialog" max-width="50vw">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card class="primary primaryText--text">
            <v-card-title>
              <span class="scada-title">{{ plantName }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs4>
                    <v-text-field
                      :label="$t('Revision')"
                      v-model="newRevisionId"
                      disabled
                      required
                    />
                  </v-flex>
                  <v-flex xs4>
                    <v-select
                      :items="[
                        'Curtailment',
                        'Grid Outage',
                        'Internal Plant',
                        'Weather Variation',
                      ]"
                      :label="$t('Reason')"
                      v-model="reason"
                      :placeholder="$t('Reason')"
                      dense
                      outlined
                      :rules="[(v) => !!v || $t('This field is required')]"
                    />
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      :label="$t('Remarks')"
                      :placeholder="$t('Any Comments')"
                      v-model="remarks"
                      persistent-hint
                      :rules="[(v) => !!v || $t('This field is required')]"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
              <v-data-table
                :headers="dialogHeader"
                :items="dialogData"
                class="header"
                :style="{ height: '300px' }"
                hide-actions
              >
                <template v-slot:items="props">
                  <tr>
                    <td
                      v-for="(head, index) in dialogHeader"
                      :key="`${head.value}-${index}`"
                      class="text-xs-center"
                    >
                      <v-text-field
                        v-if="head.value == 'forecast_gen'"
                        class="dataTableInputWidth"
                        v-model="props.item[head.value]"
                        @change="
                          (val) =>
                            generationChangeHandler(val, props.item['time'])
                        "
                      />
                      <span v-else>{{ props.item[head.value] }}</span>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <small>*{{ $t("Indicates required field") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                class="scada-btn-font"
                outlined
                color="blue darken-1"
                @click="addRevisionHandler"
                :disabled="!valid"
              >
                {{ $t("Submit") }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
const momentTz = require('moment-timezone');
import moment from "moment";
import ForecastService from "@/services/Forecast.js";
import { mapGetters, mapMutations } from "vuex";
import { mapGettersMixin } from "@/util/mixin/index";
import GlobalGraph from "@/components/common/GlobalGraph";
import TableButtons from "@/components/CustomReport/TableButtons";

export default {
  components: {
    GlobalGraph,
    TableButtons,
  },
  mixins: [mapGettersMixin],
  props: {
    changesFromFilter: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      fab: false,
      showTooltip: false,
      dialog: false,
      currentView: "graph",
      pieView: "dev",
      graphModel: "Model-1", 
      dialogData: [],
      penalty: {
        total: null,
        details: {},
      },
      penaltyTrend: {
        Today: null,
        Yesterday: null,
        Diff: null,
        Trend: "",
      },
      summary: {},
      series: [],
      xAxis: [],
      yAxis: [
        {
          type: "value",
          name: "Generation (kWh)",
          min: 0,
          position: "left",
          axisLabel: {
            color: "#fff",
          },
          nameTextStyle: {
            color: "#fff",
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#fff",
            },
          },
        },
      ],
      forecastTableData: [],
      items: [],
      pieData: [],
      models: [
        "Model-1",
        "Model-2"
      ],
      legend: {
        left: "center",
        orient: "horizontal",
        bottom: 50,
      },
      actualTotalGen: null,
      forecastedTotalGen: null,
      weatherData: {
        "Wind Speed": null,
        Temperature: null,
        Humidity: null,
        Irradiance: null,
        "Wind Direction": null,
        Condition: "",
      },
      plantName: "",
      revisedGen: {},
      newRevisionId: "R-0",
      reason: "",
      remarks: "",
      dateFrom: "",
      dateTo: "",
      valid: false,
      enableWatch: false,
      filter: [
        {
          id: "selectedRange",
          type: "select",
          title: "Choose Date Range",
          value: [
            {
              interval: "daily",
              startOffset: 0,
              endOffset: 0,
              format: "minute",
              text: "Today",
            },
            {
              interval: "daily",
              startOffset: 1,
              endOffset: 1,
              format: "minute",
              text: "Yesterday",
            },
            {
              interval: "daily",
              startOffset: 2,
              endOffset: 0,
              format: "daily",
              text: "Last 3 days",
            },
            {
              interval: "daily",
              startOffset: 6,
              endOffset: 0,
              format: "daily",
              text: "Last 7 days",
            },
            {
              interval: "daily",
              startOffset: 29,
              endOffset: 0,
              format: "daily",
              text: "Last 30 days",
            },
            {
              interval: "daily",
              offsetLevel: "month",
              startOffset: 0,
              endOffset: 0,
              format: "daily",
              text: "Present month",
            },
            {
              interval: "daily",
              offsetLevel: "month",
              startOffset: 1,
              endOffset: 1,
              format: "daily",
              text: "Last month",
            },
            {
              interval: "monthly",
              offsetLevel: "month",
              startOffset: 2,
              endOffset: 0,
              format: "monthly",
              text: "Last 3 months",
            },
            {
              interval: "monthly",
              offsetLevel: "year",
              startOffset: 0,
              endOffset: 0,
              format: "monthly",
              text: "Present Year",
            },
            {
              interval: "monthly",
              offsetLevel: "year",
              startOffset: 1,
              endOffset: 1,
              format: "monthly",
              text: "Last Year",
            },
            {
              interval: "custom",
              text: "Custom",
            },
          ],
        },
        {
          ref: "selectedRange",
          id: "Date",
          type: "datePicker",
          title: "Select Date Range",
          condition: (ref) => {
            if (ref.text === "Custom") {
              return true;
            } else {
              return false;
            }
          },
        },
      ],
      activeFilter: {},
    };
  },
  computed: {
    ...mapGetters(["getGeneralState", "getPlantName", "getSelectedPlantId", "getActivePlantTimezone"]),
    currentLanguage() {
      return this.getGeneralState("language");
    },
    activeWatch() {
      return `${this.dateFrom} ${this.dateTo}`;
    },
    watchDates() {
      return this.activeFilter.Date
        ? `${this.activeFilter.Date.from} ${this.activeFilter.Date.to}`
        : null;
    },
    tableHeight() {
      const screenResWidth = window.screen.width * window.devicePixelRatio;
      if (screenResWidth <= 2544 && screenResWidth >= 1584) {
        return "26vh";
      } else if (screenResWidth <= 1584 && screenResWidth >= 1394) {
        return "23vh";
      } else {
        return "21vh";
      }
    },
    dialogHeader() {
      return [
        {
          text: this.$t("Previous Revision Id"),
          align: "center",
          value: "revision_id",
          sortable: true,
        },
        {
          text: this.$t("Time"),
          align: "center",
          value: "time",
          sortable: true,
        },
        {
          text: this.$t("Forecast Generation (MWh)"),
          align: "center",
          value: "forecast_gen",
          sortable: true,
        },
      ];
    },
    forecastTableHeader() {
      return [
        {
          key: this.$t("Time"),
          value: "time",
          sortable: true,
        },
        {
          key: this.$t("Actual"),
          value: "actual",
          sortable: true,
        },
        {
          key: this.$t("Forecast"),
          value: "forecast",
          sortable: true,
        },
      ];
    },
  },
  async mounted() {
    const Obj = {}
    const cloneFilterOption = _.cloneDeep(this.filter);
    cloneFilterOption.forEach(child => {
      if ((child.condition && (!!child.considerStateAlways || child.condition(Obj[child.ref]))) || !child.condition) {
        if (child.type === 'select') {
          if (typeof child.value === 'function') {
            Obj[child.id] = child.value(Obj[child.ref])
          } else {
            Obj[child.id] = child.value[0]
          }
        } else if (child.type === 'datePicker' || child.type === 'singleDatePicker') {
          let parameters = ['from', 'to']
          parameters.forEach(key => {
            if (!Obj[child.id]) { Obj[child.id] = {} }
            Obj[child.id][key] = momentTz().tz(this.getActivePlantTimezone).format('YYYY-MM-DD')
          })
        } else {
          Obj[child.id] = child.value
        }
      }
    })
    this.activeFilter = Obj;
    this.$emit("filter:config", cloneFilterOption);
    this.$emit('initial:active_filter', Obj)

    this.SET_PROGRESS_BAR(true);
    await this.setIntervalWithoutDelay(this.initialCall, 3600000);
    this.SET_PROGRESS_BAR(false);
  },
  methods: {
    ...mapMutations([
      "SET_PROGRESS_BAR",
      "SET_SHOW_SNACKBAR",
      "SET_SNACKBAR_CONTENT"
    ]),
    activateTooltip() {
      setTimeout(() => {
        this.showTooltip = !this.showTooltip;
      }, 500);
    },
    async initialCall() {
      if (this.activeFilter.selectedRange.text !== "Custom") {
        let param = this.computeParam();
        this.dateFrom = param.from;
        this.dateTo = param.to;
      }
      await Promise.all([
        this.totalGenHandler(),
        this.weatherDataHandler(),
        this.penaltyTrendHandler(),
        this.revisionCardHandler(),
        this.lineGraphHandler(),
        this.deviationGraphHandler(),
        this.penaltyVsGenHandler(),
        this.summaryHandler(),
      ]);
      this.enableWatch = true;
      this.plantName = this.getPlantName(this.getSelectedPlantId);
    },
    computeParam() {
      // Function runs only when the selected range value is not custom
      const tz = this.getActivePlantTimezone;
      const param = {};
      param["type"] = this.activeFilter["selectedRange"].interval;
      if (this.activeFilter["selectedRange"].interval === "daily") {
        if (this.activeFilter["selectedRange"].offsetLevel === "month") {
          param.from = momentTz().tz(tz)
            .subtract(
              this.activeFilter["selectedRange"].startOffset,
              this.activeFilter["selectedRange"].offsetLevel
            )
            .startOf(this.activeFilter["selectedRange"].offsetLevel)
            .format("YYYY-MM-DD");
          param.to = momentTz().tz(tz)
            .subtract(
              this.activeFilter["selectedRange"].endOffset,
              this.activeFilter["selectedRange"].offsetLevel
            )
            .endOf(this.activeFilter["selectedRange"].offsetLevel)
            .format("YYYY-MM-DD");
        } else {
          param.from = momentTz().tz(tz)
            .subtract(this.activeFilter["selectedRange"].startOffset, "day")
            .format("YYYY-MM-DD");
          param.to = momentTz().tz(tz)
            .subtract(this.activeFilter["selectedRange"].endOffset, "day")
            .format("YYYY-MM-DD");
        }
      } else if (this.activeFilter["selectedRange"].interval === "monthly") {
        let format = "YYYY-MM-DD";
        param.from = momentTz().tz(tz)
          .subtract(
            this.activeFilter["selectedRange"].startOffset,
            this.activeFilter["selectedRange"].offsetLevel
          )
          .startOf(this.activeFilter["selectedRange"].offsetLevel)
          .format(`${format}`);
        param.to = momentTz().tz(tz)
          .subtract(
            this.activeFilter["selectedRange"].endOffset,
            this.activeFilter["selectedRange"].offsetLevel
          )
          .endOf(this.activeFilter["selectedRange"].offsetLevel)
          .format(`${format}`);
      }
      return param;
    },
    async totalGenHandler() {
      try {
        const response = await ForecastService.getTotalGeneration(
          this.getSelectedPlantId,
          this.graphModel
        );
        this.actualTotalGen = response.data.message["Actual Gen"];
        this.forecastedTotalGen = response.data.message["Forecasted Gen"];
      } catch (error) {
        this.actualTotalGen = null;
        this.forecastedTotalGen = null;
        console.log(error, "ERROR");
      }
    },
    async weatherDataHandler() {
      try {
        const response = await ForecastService.getWeatherData(
          this.getSelectedPlantId
        );
        this.weatherData = response.data.message;
      } catch (error) {
        console.log(error, "ERROR");
      }
    },
    async penaltyTrendHandler() {
      try {
        const response = await ForecastService.getPenaltyTrendData(
          this.getSelectedPlantId
        );
        this.penaltyTrend = response.data.message;
      } catch (error) {
        console.log(error, "ERROR");
      }
    },
    async lineGraphHandler() {
      try {
        this.series = [];
        this.forecastTableData = [];
        this.xAxis = [];
        const response = await ForecastService.getGraphData(
          this.getSelectedPlantId,
          this.dateFrom,
          this.dateTo,
          this.graphModel
        );
        // handle success
        let graphType = "line";
        if (!moment(this.dateFrom).isSame(this.dateTo, "day")) {
          graphType = "bar";
        }
        const forecastObj = {
          name: this.$t("Forecast"),
          type: graphType,
          data: [],
        };
        const actualObj = {
          name: this.$t("Actual"),
          type: graphType,
          data: [],
        };
        response.data.message.forEach((el) => {
          const tableData = {
            time: el.time,
            forecast: el.forecast,
            actual: el.actual,
          };
          const revisionObj = {
            revision_id: el.revisionId,
            time: el.time,
            forecast_gen: el.forecast,
          };
          this.dialogData.push(revisionObj);
          forecastObj.data.push(el.forecast);
          actualObj.data.push(el.actual);
          this.forecastTableData.push(tableData);
          this.xAxis.push(el.time);
        });
        this.series.push(...[forecastObj, actualObj]);
      } catch (error) {
        this.forecastTableData = [];
        this.series = [];
        this.xAxis = [];
        console.log(error, "ERROR");
      }
    },
    async summaryHandler() {
      try {
        const response = await ForecastService.getSummaryData(
          this.getSelectedPlantId,
          this.dateFrom,
          this.dateTo,
          this.graphModel
        );
        this.summary = response.data.message;
      } catch (error) {
        console.log(error, "ERROR");
      }
    },
    async deviationGraphHandler() {
      try {
        let pieValue = [];
        const response = await ForecastService.getDeviationCountData(
          this.getSelectedPlantId,
          this.dateFrom,
          this.dateTo
        );
        Object.keys(response.data.message[0]).forEach((key) => {
          let newObj = {};
          newObj["value"] =
            response.data.message[0][key] == null ||
            response.data.message[0][key] == undefined
              ? 0
              : response.data.message[0][key];
          newObj["name"] = key;
          pieValue.push(newObj);
        });
        this.pieData = pieValue;
      } catch (error) {
        this.pieData = [];
        console.log(error, "ERROR");
      }
    },
    async penaltyVsGenHandler() {
      try {
        const response = await await ForecastService.getPenaltyVsGenerationData(
          this.getSelectedPlantId,
          this.dateFrom,
          this.dateTo
        );
        this.penalty.details = response.data.message;
      } catch (error) {
        console.log(error, "ERROR");
      }
    },
    async revisionCardHandler() {
      try {
        const response = await ForecastService.getRevisionData(
          this.getSelectedPlantId,
          this.dateFrom,
          this.dateTo
        );
        let tempRevision = 0;
        this.items = response.data.message.map((el) => {
          if (tempRevision < el["revisionNo"]) {
            tempRevision = el["revisionNo"];
          }
          el["date"] = momentTz(el["date"]).tz(this.getActivePlantTimezone).format("YYYY-MM-DD HH:mm:ss");
          return el;
        });
        this.newRevisionId = `R-${tempRevision + 1}`;
      } catch (error) {
        console.log(error, "ERROR");
      }
    },
    generationChangeHandler(val, time) {
      this.$set(this.revisedGen, time, val);
    },
    async addRevisionHandler() {
      if (this.$refs.form.validate()) {
        if (Object.keys(this.revisedGen).length > 0) {
          try {
            this.SET_PROGRESS_BAR(true);
            const revisionNo = this.newRevisionId.split("-")[1];
            const payload = {
              revisionId: revisionNo,
              revisionNo: revisionNo,
              plantId: this.getSelectedPlantId,
              date: momentTz().tz(this.getActivePlantTimezone).format("YYYY-MM-DD"),
              reason: this.reason,
              remarks: this.remarks,
              revisedData: this.revisedGen,
            };
            const response = await ForecastService.postRevision(payload);
            if (response.status == 200) {
              Object.keys(this.revisedGen).forEach((timeRevised) => {
                const dialogIndex = this.dialogData.findIndex(
                  (item) => timeRevised == item.time
                );
                if (dialogIndex >= 0) {
                  this.$set(
                    this.dialogData[dialogIndex],
                    "revision_id",
                    payload["revisionId"]
                  );
                }

                // Updating the revision card
                const itemObj = {};
                itemObj["revisionNo"] = payload["revisionId"];
                itemObj["generation"] = this.revisedGen[timeRevised];
                itemObj["reason"] = payload["reason"];
                itemObj["remarks"] = payload["remarks"];
                itemObj["date"] = timeRevised;
                this.items.push(itemObj);

                // For graph & table to update according to the revision added
                const graphIndex = this.xAxis.findIndex(
                  (time) => time == timeRevised
                );
                const tableIndex = this.forecastTableData.findIndex(
                  (item) => item.time == timeRevised
                );
                this.$set(
                  this.forecastTableData[tableIndex],
                  "forecast",
                  this.revisedGen[timeRevised]
                );
                this.$set(
                  this.series[0].data,
                  graphIndex,
                  this.revisedGen[timeRevised]
                );
              });
              this.newRevisionId = `R-${parseInt(revisionNo) + 1}`;
              this.revisedGen = {};
              this.reason = "";
              this.remarks = "";
              this.dialog = false;
            }
            this.SET_PROGRESS_BAR(false);
          } catch (error) {
            console.log(error, "ERROR");
            this.SET_PROGRESS_BAR(false);
          }
        } else {
          // Error message where Forecasted generation has not changed
          let payload = {
            icon: "error",
            header: "",
            message: "Forecasted Generation is not edited!",
          };
          this.SET_SNACKBAR_CONTENT(payload);
          this.SET_SHOW_SNACKBAR(true);
        }
      }
    },
    async download() {
      const param = {
        plantId: this.getSelectedPlantId,
        plantName: this.getPlantName(this.getSelectedPlantId),
        fromDate: this.dateFrom,
        toDate: this.dateTo,
        model: this.graphModel
      };
      let encoded = btoa(JSON.stringify(param));
      this.SET_PROGRESS_BAR(true);
      await ForecastService.download(encoded);
      this.SET_PROGRESS_BAR(false);
    },
  },
  watch: {
    changesFromFilter: {
      handler(val) {
        this.activeFilter = val;
      },
      deep: true,
    },
    "activeFilter.selectedRange.text"() {
      if (this.activeFilter.selectedRange.text === "Custom") {
        this.dateFrom = this.activeFilter.Date.from
        this.dateTo = this.activeFilter.Date.to
        this.dateInfo = `${this.dateFrom} - ${this.dateTo}`;
      } else {
        const param = this.computeParam();
        this.dateInfo = `${this.activeFilter.selectedRange.text}`;
        this.dateFrom = param.from;
        this.dateTo = param.to;
      }
    },
    async activeWatch(val, oldVal) {
      if (this.enableWatch && !oldVal.includes("null")) {
        this.SET_PROGRESS_BAR(true);
        await Promise.all([
          this.revisionCardHandler(),
          this.lineGraphHandler(),
          this.deviationGraphHandler(),
          this.penaltyVsGenHandler(),
          this.summaryHandler(),
        ]);
        this.SET_PROGRESS_BAR(false);
      }
    },
    watchDates(val, oldVal) {
      if (
        this.activeFilter.selectedRange.text === "Custom" &&
        oldVal !== null
      ) {
        this.dateFrom = val.split(" ")[0];
        this.dateTo = val.split(" ")[1];
      }
    },
    async getSelectedPlantId() {
      if (this.enableWatch) {
        this.SET_PROGRESS_BAR(true);
        await this.setIntervalWithoutDelay(this.initialCall, 3600000);
        this.SET_PROGRESS_BAR(false);
      }
    },
    currentLanguage() {
      this.yAxis[0].name = this.$t("Generation (kWh)");
      if (this.series.length > 0) {
        this.$set(this.series[0], "name", this.$t("Forecast"));
        this.$set(this.series[1], "name", this.$t("Actual"));
      }
    },
    graphModel() {
      this.lineGraphHandler();
      this.totalGenHandler();
      this.summaryHandler();
    }
  },
};
</script>

<style scoped>
.header {
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #38405c;
}

.line-chart-card {
  width: 100%;
  height: 46.6vh;
}

.graph {
  width: 100%;
  height: 33.2vh;
}

.pie-chart-card {
  height: 36vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.pie-graph {
  width: 100%;
  height: 27.2vh;
}

.scada-toggle-height {
  height: 36px;
}

.scada-btn-font {
  font-size: 14px;
}

.scada-icon-medium {
  font-size: 28px;
}

.scada-title {
  font-size: 20px;
}

.scada-subheading {
  font-size: 16px;
}

.scada-body-2 {
  font-size: 14px;
}

.clouded-png {
  width: 85px;
}

.main-card {
  height: 15vh;
}

.range-card {
  height: 36vh;
}

.revision-card {
  width: 100%;
  height: 15.2vh;
}

.combobox-card {
  height: 36vh;
}

.weather-card {
  height: 15vh;
}

.paddingTopBottom1vw {
  padding: 0vw 1vw;
}

.paddingBottom1vw[data-v-1db0e6b5] {
  padding: 0vw 0vw 1vw;
}

.dataTableInputWidth {
  margin: auto;
  width: 80px;
}
</style>

<style scoped>
@media (min-width: 1030px) and (max-width: 1366px) {
  .pie-graph {
    width: 100%;
    height: 22vh;
  }
  .scada-btn-font {
    font-size: 10px;
  }
  .scada-toggle-height {
    height: 28px;
  }
  .scada-icon-medium {
    font-size: 18px;
  }
}

@media only screen and (min-height: 600px) and (max-height: 720px) {
  .main-card {
    height: 122px;
  }
  .graph {
    width: 100%;
    height: 302px;
  }
  .line-chart-card {
    width: 100%;
    height: 382px;
  }
  .pie-graph {
    width: 100%;
    height: 22vh;
  }
  .scada-title {
    font-size: 16px;
  }
  .scada-subheading {
    font-size: 12px;
  }
  .scada-body-2 {
    font-size: 10px;
  }
  .clouded-png {
    width: 60px;
  }
  .scada-btn-font {
    font-size: 10px;
  }
  .scada-toggle-height {
    height: 28px;
  }
  .scada-icon-medium {
    font-size: 18px;
  }
}

@media only screen and (min-height: 721px) and (max-height: 768px) {
  .main-card {
    height: 144px;
  }
  .graph {
    width: 100%;
    height: 322px;
  }
  .line-chart-card {
    width: 100%;
    height: 362px;
  }
  .scada-title {
    font-size: 16px;
  }

  .scada-subheading {
    font-size: 12px;
  }

  .scada-body-2 {
    font-size: 10px;
  }

  .clouded-png {
    width: 60px;
  }
}
/* don't know if it will be used */
/* @media only screen and (min-height: 769px) and (max-height: 800px) {
  .graph {
    width: 100%;
    height: 36vh;
  }
  .line-chart-card {
    width: 100%;
    height: 324px;
  }
} */

/* 
@media only screen and (max-height: 960px) {
  .graph {
    width: 100%;
    height: 32vh;
  }
  .line-chart-card {
    width: 100%;
    height: 348px;
  }
}

@media only screen and (max-height: 1024px) {
  .graph {
    width: 100%;
    height: 34vh;
  }
  .line-chart-card {
    width: 100%;
    height: 412px;
  }
} */
</style>

<style>
.header .v-table__overflow {
  overflow: unset;
}

table.v-table thead tr {
  height: 38px;
}
</style>
